<template>
  <div class="col-sm-12">
    <div class="card">
      <div class="table-responsive">
        <table class="table">
          <thead>
            <tr>
              <th scope="col" class="text-center">Operaciones</th>
              <th scope="col" class="text-center">Estado</th>
              <th scope="col" class="text-center">Evento</th>
              <th scope="col" class="text-center">Fecha Inicio</th>
              <th scope="col" class="text-center">Fecha Fin</th>
              <th scope="col" class="text-center">Tipo</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(item, index) in paginatedItems" :key="item.id">
              <td class="text-center">
                <button class="btn btn-success" @click="getEvent(item.id)">
                  Participantes
                </button>
              </td>
              <td class="text-center">{{ item.state }}</td>
              <td class="text-center" style="max-width: 250px">
                {{ item.title }}
              </td>
              <td class="text-center">{{ formatDate(item.init_date) }}</td>
              <td class="text-center">{{ formatDate(item.end_date) }}</td>
              <td class="text-center">{{ item.mode }}</td>
            </tr>
          </tbody>
        </table>
      </div>
      <pagination
        :totalItems="list.length"
        :itemsPerPage="itemsPerPage"
        @page-change="handlePageChange"
      />
    </div>
  </div>
</template>

<script setup>
import { onMounted, ref, inject, computed } from "vue";
import axios from "@/includes/connection";

import Pagination from "@/pages/components/Pagination.vue";

const list = ref([]);

const swal = inject("$swal");

import { useRouter } from "vue-router";
const router = useRouter();

onMounted(() => {
  loadItems();
});

function formatDate(dateString) {
  const date = new Date(dateString);
  return new Intl.DateTimeFormat("fr-CA", {
    year: "numeric",
    month: "2-digit",
    day: "2-digit",
  }).format(date);
}

function loadItems() {
  axios
    .get("/certification/legacy-events")
    .then((response) => {
      console.log("list", response.data);
      if (response.data) {
        list.value = response.data;
      }
    })
    .catch(function (error) {
      console.log(error);
    });
}

const getEvent = (code) => {
  console.log(code);
  router.push({ name: "history-participants", params: { id: code } });
};

const getAttendance = (code) => {
  console.log(code);
  router.push({ name: "list_participants_attendance", params: { id: code } });
};

const sortedList = computed(() => {
  return list.value.sort((a, b) => b.id - a.id);
});

let currentPage = ref(1);
let itemsPerPage = ref(10);

let paginatedItems = computed(() => {
  const startIndex = (currentPage.value - 1) * itemsPerPage.value;
  const endIndex = startIndex + itemsPerPage.value;
  return sortedList.value.slice(startIndex, endIndex);
});

function handlePageChange(page) {
  currentPage.value = page;
}
</script>
